import apiCredits from '../_ApiConn/apiCredits';


// excludeOrderNum — ההזמנה שהלקוח מנסה לשלם עליה כרגע.
// בלעדיה, ניסיון תשלום חוזר על אותה הזמנה יראה 0 קרדיטים זמינים.
const getMyCredits = async (excludeOrderNum) => {
    return await apiCredits.getMyCredits(localStorage.getItem("usrtoken"), excludeOrderNum);
};

const getMyCreditsLog = async () => {
    return await apiCredits.getMyCreditsLog(localStorage.getItem("usrtoken"));
};

export default { getMyCredits, getMyCreditsLog };
